<div
  class="group relative flex min-h-16 w-full justify-between bg-transparent py-3 pr-4 pl-2 text-sm"
  [ngClass]="{
    'cursor-move hover:bg-gray-50': isMovable(),
    'rounded border': isDragPreview(),
    'border-b': drawBottomBorder(),
  }"
  *transloco="let t"
>
  <div class="flex min-w-0 items-center gap-2">
    @if (isMovable()) {
      <app-drag-icon />
    }
    @if (excluded()) {
      <IBadge [label]="t('common.exclude') | titlecase" color="white" />
    }
    <div class="truncate">{{ audience().audienceName }}</div>
  </div>
  @if (!isReadOnly() && isInAudienceGroup() && !isPlaceholder()) {
    <div class="absolute top-1/2 right-1 hidden -translate-y-1/2 group-hover:flex">
      <button
        iButton
        variant="secondary"
        size="icon-sm"
        (click)="clicked.emit()"
        [iTooltip]="t('dsp-create-strategy-page.remove_audience')"
      >
        <IIcon name="trash" />
      </button>
    </div>
  }
  <div class="ml-2 flex items-center justify-center gap-2 text-xs">
    <IBadge color="gray">
      <ng-template #labelSlot>
        <span class="text-gray-700">
          {{ audience().category }}
          @if (!isActive()) {
            ·
            <span [class]="isFailed() ? 'text-red-600' : 'text-orange-500'"> {{ audience().status }}</span>
          }
          @if (displayFee()) {
            ·
            <span>
              {{
                t("common.fee_with_amount", [
                  audience().fee | currency: marketplaceCurrency() : "symbol-narrow" : "1.0-1" : locale(),
                ]) | titlecase
              }}</span
            >
          }
        </span></ng-template
      >
    </IBadge>
  </div>
  @if (isInAudienceGroup() && !isLastInGroup() && !isPlaceholder()) {
    <div class="absolute -bottom-[0.8rem] z-10 ml-2 flex w-full">
      <IBadge [label]="(operator() === 'or' ? t('common.or') : t('common.and')) | titlecase" color="gray" />
    </div>
  }
</div>
